import { GitContributors } from "/workspaces/ft-docs/node_modules/@vuepress/theme-default/node_modules/@vuepress/plugin-git/lib/client/components/GitContributors.js";
import { GitChangelog } from "/workspaces/ft-docs/node_modules/@vuepress/theme-default/node_modules/@vuepress/plugin-git/lib/client/components/GitChangelog.js";

export default {
  enhance: ({ app }) => {
    app.component("GitContributors", GitContributors);
    app.component("GitChangelog", GitChangelog);
  },
};
